import OrderDTO from "@/dto/order/OrderDTO";
import React from "react";
import OrderRemark from "./OrderRemark";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";

interface OrderRemarkColumnProps {
    order: OrderDTO;
}

const OrderRemarkColumn: React.FC<OrderRemarkColumnProps> = function (props) {
    const { order } = props;

    const orderManagementStore = useOrderManagementStore();

    return (
        <td>
            <OrderRemark order={order} onUpdateOrder={orderManagementStore.table.updateOrder} />
        </td>
    );
};

export default React.memo(OrderRemarkColumn);
